var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-linkedin",
    "data-name": "Icon awesome-linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.508,
    height: 14.508,
    viewBox: "0 0 14.508 14.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-2",
    "data-name": "Icon awesome-linkedin",
    d: "M13.472,2.25H1.033A1.041,1.041,0,0,0,0,3.3V15.712a1.041,1.041,0,0,0,1.033,1.046H13.472a1.044,1.044,0,0,0,1.036-1.046V3.3A1.044,1.044,0,0,0,13.472,2.25ZM4.385,14.685H2.234V7.762H4.388v6.924ZM3.31,6.816A1.247,1.247,0,1,1,4.556,5.569,1.247,1.247,0,0,1,3.31,6.816Zm9.135,7.869h-2.15V11.317c0-.8-.016-1.836-1.117-1.836-1.12,0-1.292.874-1.292,1.778v3.426H5.735V7.762H7.8v.946h.029A2.265,2.265,0,0,1,9.864,7.59c2.176,0,2.581,1.435,2.581,3.3Z",
    transform: "translate(0 -2.25)",
    fill: "#00649e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d95a57afc628ab96d9b394b53c4fd54a.svg";
export { ForwardRef as ReactComponent };